import { Navigate, Outlet } from "react-router-dom";


const isAuthenticated = () => {
  return localStorage.getItem("isAdmin") === "true";
};

const RequireAuth = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/dashboard/login" replace />;
};

export default RequireAuth;
